import {
    UI_SPORT_LIVE_ACTIVE_SPORT,
    UI_SPORT_LIVE_EVENTS_BY_SPORT,
    UI_SPORT_LIVE_SEARCH_TEXT,
} from 'constants/ui';

export function setActiveSportId(id) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_LIVE_ACTIVE_SPORT,
            payload: id,
        });
    };
}

export function setEventsBySport(events) {
    let data = {};

    for (let key in events) {
        if (events.hasOwnProperty(key)) {
            const item = events[key];

            if (!data[item.sportId]) {
                data[item.sportId] = {};
            }

            data[item.sportId][key] = item;
        }
    }

    return (dispatch) => {
        dispatch({
            type: UI_SPORT_LIVE_EVENTS_BY_SPORT,
            payload: data,
        });
    };
}

export function search(text) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_LIVE_SEARCH_TEXT,
            payload: text,
        });
    };
}
